import * as React from 'react';
const SvgYoutube = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="#E55040"
      d="M0 9.6c0-3.36 0-5.04.654-6.324A6 6 0 0 1 3.276.654C4.56 0 6.24 0 9.6 0h4.8c3.36 0 5.04 0 6.324.654a6 6 0 0 1 2.622 2.622C24 4.56 24 6.24 24 9.6v4.8c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C19.44 24 17.76 24 14.4 24H9.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C0 19.44 0 17.76 0 14.4z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M19.01 5.89c.776.214 1.38.842 1.59 1.643.549 2.286.513 6.608.012 8.93a2.29 2.29 0 0 1-1.59 1.643c-2.189.56-11.994.49-14.056 0a2.29 2.29 0 0 1-1.59-1.643c-.517-2.18-.482-6.787-.011-8.918a2.29 2.29 0 0 1 1.59-1.643C7.88 5.27 17.969 5.474 19.01 5.89M9.43 9.248c0-.505.545-.817.973-.557l4.536 2.752a.654.654 0 0 1 0 1.114l-4.536 2.752a.643.643 0 0 1-.973-.557z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgYoutube;
